const typeGroupPublisher = {
  BANNER: "banner",
  NATIVE: "native",
  PUSH: "push",
  BANNER_ALTERNATIVE: "banner_alternative",
};

const getTypeGroupPublisherNumber = () => {
  let data = {};
  data[typeGroupPublisher.BANNER] = 1;
  data[typeGroupPublisher.NATIVE] = 2;
  data[typeGroupPublisher.PUSH] = 3;
  data[typeGroupPublisher.BANNER_ALTERNATIVE] = 4;

  return data;
};

const getTypeGroupPublisherPersianName = () => {
  let data = {};
  data[typeGroupPublisher.BANNER] = "بنری";
  data[typeGroupPublisher.NATIVE] = "همسان";
  data[typeGroupPublisher.PUSH] = "پوش";
  data[typeGroupPublisher.BANNER_ALTERNATIVE] = "بنری جایگزین";

  return data;
};

const getTypePersianNameGroupPublisher = (status) => {
  return getTypeGroupPublisherPersianName()[status];
};
const getTypeGroupPublisher = (status) => {
  return getTypeGroupPublisherNumber()[status];
};

export default {
  getTypePersianNameGroupPublisher,
  getTypeGroupPublisher,
  typeGroupPublisher,
};
